import { post, IRequest } from '../index';
import { IAddDataModel, IUpdateDataModel } from '../../models/storeDisplay';

export const getDisplaysApi = () => {
	const request: IRequest = {
		subUrl: '/retailer/displays',
	};
	return post(request);
};

export const getAssetsApi = () => {
	const request: IRequest = {
		subUrl: '/retailer/assets',
	};
	return post(request);
};

export const addDataApi = (data: IAddDataModel) => {
	const request: IRequest = {
		subUrl: '/retailer/addorupdateasset',
		data,
	};
	return post(request);
};

export const updateDataApi = (data: IUpdateDataModel) => {
	const request: IRequest = {
		subUrl: '/retailer/addorupdateasset',
		data,
	};
	return post(request);
};

export const getReasonApi = () => {
	const request: IRequest = {
		subUrl: '/appconfig/reasonmaster',
	};
	return post(request);
};

export const getConditionApi = (data: IGetSearchStoreProducts) => {
	const request: IRequest = {
		subUrl: '/appconfig/conditionmaster',
	};
	return post(request);
};
